import React from "react";
import { DeleteForever } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";

const ActivityTableRow = ({
  subhead,
  deptIndex,
  subheadIndex,
  scheme,
  authData,
  activity,
  formData,
  handleActivityChange,
  findSubActivitiesById,
  handleSubheadBudgetFormData,
  addNewActivity,
  deleteNewActivity,
  changeSubheadBudget,
}) => {
  const isT1 =
    scheme.monitoring_level == "3" &&
    authData.user.department_details.department_level == "T1";

  if (scheme.is_activity_active == "1" && scheme.monitoring_level != "2") {
    return (
      <tr>
        <td colSpan="8">
          <div className="row">
            <div className="table-responsive custom-table">
              <table className="table table-bordered">
                <thead className="text-center-custom">
                  <tr>
                    <th scope="col">Activity</th>
                    <th scope="col">Subactivity</th>
                    {!isT1 && <th scope="col">Provisional Budget</th>}
                    <th scope="col">Provisioned Allocation</th>
                    {!isT1 && <th scope="col">Release Balance</th>}
                    <th scope="col">Released Allocation</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody className="text-center-custom">
                  {subhead.activity.map((activityData, activityIndex) => (
                    <tr key={activityIndex}>
                      <td>
                        <select
                          className="form-control"
                          name="activity_id"
                          value={activityData.activity_id}
                          disabled={!subhead.subhead_id}
                          onChange={(e) =>
                            handleActivityChange(
                              e.target.value,
                              "",
                              activityIndex,
                              deptIndex,
                              subheadIndex,
                            )
                          }
                        >
                          <option value="">---Select---</option>
                          {activity.map((act) => {
                            const exists = subhead.activities.find(
                              (e) => e.subhead_activity_id == act.id,
                            );
                            const activityMatchesScheme =
                              act.scheme_id != null &&
                              String(act.scheme_id) ===
                                String(scheme.id);
                            if (exists && scheme.monitoring_level == 1) {
                              return (
                                <option key={act.id} value={act.id}>
                                  {act.activity}
                                </option>
                              );
                            } else if (
                              scheme.monitoring_level == 3 &&
                              activityMatchesScheme
                            ) {
                              return (
                                <option key={act.id} value={act.id}>
                                  {act.activity}
                                </option>
                              );
                            }
                          })}
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-control"
                          name="subactivity_id"
                          value={activityData.subactivity_id}
                          disabled={!subhead.subhead_id}
                          onChange={(e) =>
                            handleActivityChange(
                              activityData.activity_id,
                              e.target.value,
                              activityIndex,
                              deptIndex,
                              subheadIndex,
                            )
                          }
                        >
                          <option value="">---Select---</option>
                          {findSubActivitiesById(activityData.activity_id).map(
                            (e) => {
                              const exists = subhead.activities.find(
                                (ea) =>
                                  ea.subhead_activity_id ==
                                    activityData.activity_id &&
                                  ea.subhead_subactivity_id == e.id,
                              );
                              if (
                                exists &&
                                Number(scheme.monitoring_level) === 1
                              ) {
                                return (
                                  <option key={e.id} value={e.id}>
                                    {e.subactivity}
                                  </option>
                                );
                              } else if (
                                Number(scheme.monitoring_level) === 3
                              ) {
                                return (
                                  <option key={e.id} value={e.id}>
                                    {e.subactivity}
                                  </option>
                                );
                              }
                            },
                          )}
                        </select>
                      </td>
                      {!isT1 && (
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            value={(() => {
                              if (!activityData.subactivity_id)
                                return activityData.subhead_provisional_budget || "";
                              const otherDeptAllocated =
                                formData.department_Array.reduce(
                                  (sum, dept, dIdx) => {
                                    if (dIdx === deptIndex) return sum;
                                    dept.subHead.forEach((sh) => {
                                      sh.activity.forEach((act) => {
                                        if (
                                          act.activity_id ===
                                            activityData.activity_id &&
                                          act.subactivity_id ===
                                            activityData.subactivity_id
                                        ) {
                                          sum += Number(
                                            act.provisional_budget || 0,
                                          );
                                        }
                                      });
                                    });
                                    return sum;
                                  },
                                  0,
                                );
                              return Math.max(
                                0,
                                (Number(
                                  activityData.subhead_provisional_budget,
                                ) || 0) - otherDeptAllocated,
                              );
                            })()}
                            readOnly={true}
                          />
                        </td>
                      )}
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          name="provisional_budget"
                          placeholder="Enter Provision Budget"
                          value={activityData.provisional_budget}
                          disabled={
                            !activityData.subactivity_id ||
                            (() => {
                              if (
                                !(
                                  formData.is_activity_active == "1" &&
                                  formData.monitoring_level == "1"
                                )
                              )
                                return false;
                              if (!activityData.subhead_provisional_budget)
                                return false;
                              const otherDeptAllocated =
                                formData.department_Array.reduce(
                                  (sum, dept, dIdx) => {
                                    if (dIdx === deptIndex) return sum;
                                    dept.subHead.forEach((sh) => {
                                      sh.activity.forEach((act) => {
                                        if (
                                          act.activity_id ===
                                            activityData.activity_id &&
                                          act.subactivity_id ===
                                            activityData.subactivity_id
                                        ) {
                                          sum += Number(
                                            act.provisional_budget || 0,
                                          );
                                        }
                                      });
                                    });
                                    return sum;
                                  },
                                  0,
                                );
                              return (
                                Math.max(
                                  0,
                                  (Number(
                                    activityData.subhead_provisional_budget,
                                  ) || 0) - otherDeptAllocated,
                                ) <= 0
                              );
                            })()
                          }
                          onChange={(e) =>
                            handleSubheadBudgetFormData(
                              deptIndex,
                              subheadIndex,
                              activityIndex,
                              e,
                            )
                          }
                        />
                      </td>
                      {!isT1 && (
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            value={(() => {
                              if (!activityData.subactivity_id)
                                return activityData.subhead_budget || "";
                              const otherDeptAllocated =
                                formData.department_Array.reduce(
                                  (sum, dept, dIdx) => {
                                    if (dIdx === deptIndex) return sum;
                                    dept.subHead.forEach((sh) => {
                                      sh.activity.forEach((act) => {
                                        if (
                                          act.activity_id ===
                                            activityData.activity_id &&
                                          act.subactivity_id ===
                                            activityData.subactivity_id
                                        ) {
                                          sum += Number(act.budget || 0);
                                        }
                                      });
                                    });
                                    return sum;
                                  },
                                  0,
                                );
                              return Math.max(
                                0,
                                (Number(activityData.subhead_budget) || 0) -
                                  otherDeptAllocated,
                              );
                            })()}
                            readOnly={true}
                          />
                        </td>
                      )}
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          name="budget"
                          placeholder="Enter Budget"
                          value={activityData.budget}
                          disabled={
                            !activityData.subactivity_id ||
                            (() => {
                              if (
                                !(
                                  formData.is_activity_active == "1" &&
                                  formData.monitoring_level == "1"
                                )
                              )
                                return false;
                              if (!activityData.subhead_budget) return false;
                              const otherDeptAllocated =
                                formData.department_Array.reduce(
                                  (sum, dept, dIdx) => {
                                    if (dIdx === deptIndex) return sum;
                                    dept.subHead.forEach((sh) => {
                                      sh.activity.forEach((act) => {
                                        if (
                                          act.activity_id ===
                                            activityData.activity_id &&
                                          act.subactivity_id ===
                                            activityData.subactivity_id
                                        ) {
                                          sum += Number(act.budget || 0);
                                        }
                                      });
                                    });
                                    return sum;
                                  },
                                  0,
                                );
                              return (
                                Math.max(
                                  0,
                                  (Number(activityData.subhead_budget) || 0) -
                                    otherDeptAllocated,
                                ) <= 0
                              );
                            })()
                          }
                          onChange={(e) =>
                            handleSubheadBudgetFormData(
                              deptIndex,
                              subheadIndex,
                              activityIndex,
                              e,
                            )
                          }
                        />
                      </td>
                      <td>
                        <button
                          className="btn btn-primary mx-2"
                          onClick={() => addNewActivity(deptIndex, subheadIndex)}
                        >
                          <AddIcon />
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger mx-2"
                          onClick={() =>
                            deleteNewActivity(deptIndex, subheadIndex, activityIndex)
                          }
                        >
                          <DeleteForever />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </td>
      </tr>
    );
  }

  return (
    <tr>
      <td colSpan="8">
        <div className="row">
          <div className="table-responsive custom-table">
            <table className="table table-bordered">
              <thead className="text-center-custom">
                <tr>
                  <th scope="col">Provisioned Allocation</th>
                  <th scope="col">Released Allocation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td scope="col">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Budget"
                      name="allocate_provision"
                      onChange={(e) =>
                        changeSubheadBudget(deptIndex, subheadIndex, e)
                      }
                      value={subhead?.allocate_provision}
                    />
                  </td>
                  <td scope="col">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Budget"
                      name="allocate_release"
                      onChange={(e) =>
                        changeSubheadBudget(deptIndex, subheadIndex, e)
                      }
                      value={subhead?.allocate_release}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default ActivityTableRow;
